import { FeatureToggles } from '@ps20-frontend/frontend-models';
import { Feature, Produktlinienname } from '@ps20/bff-models';
import { WarenkorbAngebot } from '../reducers/produkte.reducer';

export const ONE_YEAR_LAUFZEIT = 1;
export const THREE_YEARS_LAUFZEIT = 3;

export const isVertragslaufzeitChangeForbidden = (
  produkt: WarenkorbAngebot,
  featureToggles: FeatureToggles,
): boolean =>
  produkt.ausgewaehlteLinie === Produktlinienname.BASIS ||
  produkt.beibehalten ||
  (produkt.vorvertragsNummern?.length > 0 &&
    produkt.laufzeit === THREE_YEARS_LAUFZEIT &&
    !!featureToggles?.[Feature.MINDESTLAUFZEIT]);
